import {
  ModalContainer,
  ModalTopSection,
  PinCodeInput,
  SwitchAppButton,
} from "..";
import { IPinCodeInputProps } from "../PinCodeInput/PinCodeInput";

interface IPinCodeInputModalProps extends IPinCodeInputProps {
  isModalOpen: boolean;
  closeModal: () => void;
}

export const PinCodeInputModal = (props: IPinCodeInputModalProps) => {
  const { isModalOpen, closeModal, ...rest } = props;

  // if (!isModalOpen) return null;

  return (
    <ModalContainer
      isModalOpen={isModalOpen}
      closeModal={closeModal}
      className="pin-input-modal-container"
      //   modalHeader={
      //     <ModalTopSection
      //       header={props.title}
      //       subHeader={
      //         <div className="name-sub-header flex-container align-items--end justify-content--start">
      //           {props.subtitle}
      //         </div>
      //       }
      //       closeModal={props.closeModal}
      //     />
      //   }
    >
      <PinCodeInput {...rest} />

      <div className="flex-container row justify-content--center mt-5 mb-5" />
    </ModalContainer>
  );
};
